// extracted by mini-css-extract-plugin
export default {"loader-backdrop":"Loader_loader-backdrop__6+wAz"};